module.exports = __webpack_public_path__ + "img/list7.4ff7b9f9.png";